<script>
  import GameScoreTeam from './GameScoreTeam.svelte';
  import GameScoreInnings from './GameScoreInnings.svelte';
  import GameScoreTotals from './GameScoreTotals.svelte';

  export let value;
  export let team;
  export let plays;
  export let lang = undefined;
</script>

<div class='game-score'>
  <div class='game-score-team'>
    <GameScoreTeam {team} bind:lang/>
  </div>

  <div class='game-score-innings'>
    <GameScoreInnings score={value.score} plays={plays} bind:lang/>
  </div>

  <div class='game-score-totals'>
    <GameScoreTotals {value} bind:lang/>
  </div>
</div>

<style>
  .game-score {
    display: flex;
    justify-content: center;
    gap: 50px;

    padding: 10px 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  :global(body.dark) .game-score {
    background: var(--grey-8);
  }

  @media only screen and (max-width: 950px) {
    .game-score-innings {
      display: none;
    }
  }
</style>
